/**
 * @desc 红人管理-终止合作
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(kolno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/terminateCooperation/${kolno}`, {
      method: "POST",

      ...options,
    }),
  );
}
